<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Kelas Percobaan Berbayar
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-row dense>
                  <v-col cols="12" md="12">
                    <v-radio-group
                      v-model="data.is_member"
                      row
                      label="Jenis Pendaftar"
                      :mandatory="true"
                    >
                      <v-radio label="Member" :value="true" />
                      <v-radio label="Non Member" :value="false" />
                    </v-radio-group>
                    <v-autocomplete
                      v-if="data.is_member === true"
                      label="Member"
                      dense
                      outlined
                      v-model="data.member_id"
                      :items="listMembers"
                      item-text="name"
                      item-value="id"
                      :rules="memberIdRules"
                      clearable
                    />
                    <v-text-field
                      v-else
                      label="Nama Non Member"
                      dense
                      outlined
                      v-model="data.non_member_name"
                      :rules="nonMemberNameRules"
                      clearable
                    />
                    <v-autocomplete
                      label="Kelas"
                      dense
                      outlined
                      v-model="data.class_type_id"
                      :items="listClassType"
                      item-text="name"
                      item-value="id"
                      :rules="rules.class_type_id"
                    />
                    <v-autocomplete
                      label="Jadwal Kelas"
                      dense
                      outlined
                      v-model="data.class_schedule_id"
                      :items="listClassSchedule"
                      item-text="name"
                      item-value="id"
                      :rules="rules.class_schedule_id"
                    />

                    <CurrencyInput
                      v-model="data.price"
                      placeholder="Masukkan harga"
                      :rules="[(v) => !!v || 'Harga harus diisi']"
                    />
                    <v-autocomplete
                      label="Metode Pembayaran"
                      dense
                      outlined
                      v-model="data.payment_method_id"
                      :items="listPaymentMethods"
                      item-text="name"
                      item-value="id"
                      clearable
                      :rules="rules.payment_method_id"
                    />
                    <v-autocomplete
                      label="Bank Tujuan"
                      dense
                      outlined
                      v-model="data.destination_bank_id"
                      :items="listBanks"
                      item-text="name"
                      item-value="id"
                      clearable
                      :rules="rules.destination_bank_id"
                    />
                    <v-text-field
                      label="No. Rekening"
                      dense
                      outlined
                      v-model="data.account_number"
                      :rules="rules.account_number"
                    />
                    <v-text-field
                      label="Nama Rekening"
                      dense
                      outlined
                      v-model="data.account_name"
                    />
                    <v-col cols="12" md="12">
                      <div class="ml-3">Bukti Transfer</div>
                      <FileUpload
                        v-model="data.transfer_evidence_id"
                        :labelIdle="'Unggah Bukti Transfer'"
                        :key="data.transfer_evidence_id"
                        category="file"
                        class="mb-6"
                      ></FileUpload>
                    </v-col>
                    <v-textarea
                      label="Keterangan"
                      dense
                      outlined
                      v-model="data.description"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

import UploadAdapter from "../../../../core/plugins/UploadAdapter";

import FileUpload from "@/view/component/FileUpload.vue";

export default {
  async mounted() {
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;

    const paymentMethods = await ApiService.get("payment-method/list");
    this.listPaymentMethods = paymentMethods.data;

    const banks = await ApiService.get("bank/list");
    this.listBanks = banks.data;

    const classType = await ApiService.get("class-type/list");
    this.listClassType = classType.data.filter((item) => !item.is_free);
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listMembers: [],
      listPaymentMethods: [],
      listClassSchedule: [],
      listBanks: [],
      data: this.defaultData(),
      rules: {
        member_id: [
          (v) => !!v || "Member harus dipilih",
          (v) => v.length > 0 || "Member harus dipilih",
        ],
        class_type_id: [
          (v) => !!v || "Kelas harus dipilih",
          (v) => v.length > 0 || "Kelas harus dipilih",
        ],
        class_schedule_id: [
          (v) => !!v || "Jadwal kelas harus dipilih",
          (v) => v.length > 0 || "Jadwal kelas harus dipilih",
        ],
        price: [
          (v) => !!v || "Biaya harus diisi",
          (v) => v.length > 0 || "Biaya harus diisi",
        ],
        payment_method_id: [
          (v) => !!v || "Metode pembayaran harus dipilih",
          (v) => v.length > 0 || "Metode pembayaran harus dipilih",
        ],
        destination_bank_id: [
          (v) => !!v || "Bank tujuan harus dipilih",
          (v) => v.length > 0 || "Bank tujuan harus dipilih",
        ],
        account_number: [
          (v) => !!v || "No. rekening harus diisi",
          (v) => v.length > 0 || "No. rekening harus diisi",
        ],
        account_name: [
          (v) => !!v || "Nama rekening harus diisi",
          (v) => v.length > 0 || "Nama rekening harus diisi",
        ],
      },
    };
  },
  props: {
    module: {
      type: String,
    },
    success: {
      type: Function,
      default: function () {},
    },
  },
  methods: {
    async fetchClassSchedules(classTypeId) {
      this.loadingData = true;
      try {
        const response = await ApiService.get(
          `class-schedule/list?class_type_id=${classTypeId}`
        );
        this.listClassSchedule = response.data.map((item) => ({
          id: item.id,
          name: `${item.class_date} (${item.start_time} - ${item.end_time})`,
        }));

        if (this.id != null && this.data.class_schedule_id) {
          const selectedId = String(this.data.class_schedule_id);
          const exists = this.listClassSchedule.some(
            (x) => String(x.id) === selectedId
          );
          if (!exists) {
            const existingSchedule = await ApiService.get(
              `class-schedule?id=${this.data.class_schedule_id}`
            );
            if (existingSchedule.data) {
              this.listClassSchedule.unshift({
                id: existingSchedule.data.id,
                name: `${existingSchedule.data.class_date} (${existingSchedule.data.start_time} - ${existingSchedule.data.end_time}) — Kuota habis`,
                // optional: tandai disabled biar tidak bisa dipilih ulang
                // disabled: true,
              });
            }
          }
        }
      } catch (error) {
        this.handleError(error.response.data);
      } finally {
        this.loadingData = false;
      }
    },
    defaultData() {
      return {
        is_member: false,
        member_id: null,
        non_member_name: null,
        description: null,
        price: 0,
        class_type_id: null,
        class_schedule_id: null,
        payment_method_id: null,
        destination_bank_id: null,
        account_number: null,
        account_name: null,
        transfer_evidence_id: null, // biarkan default di sini, tapi jangan di-null-kan saat close setelah submit
      };
    },
    open(id) {
      this.opened = true;
      // reset validation saja; jangan menyentuh v-model file tanpa perlu
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetValidation();
      });
      if (id) {
        this.getData(id);
      } else {
        // mode create: aman reset ke default
        this.data = this.defaultData();
        this.id = null;
      }
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      try {
        const { data } = await ApiService.get("paid-trial-class?id=" + id);

        // ISI DATA DULU
        this.data = {
          is_member: data.is_member,
          non_member_name: data.non_member_name,
          price: data.price,
          class_schedule_id: data.class_schedule_id,
          class_type_id: data.class_type_id,
          description: data.description,
          member_id: data.member_id,
          payment_method_id: data.payment_method_id,
          destination_bank_id: data.destination_bank_id,
          account_number: data.account_number,
          account_name: data.account_name,
          status: data.status,
          transfer_evidence_id: data.transfer_evidence_id,
        };

        if (this.data.class_type_id) {
          await this.fetchClassSchedules(this.data.class_type_id);
        }
      } catch (err) {
        if (err.response?.data) {
          this.handleError(err.response.data);
        }
      } finally {
        this.loadingData = false;
      }
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "paid-trial-class";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
    close() {
      this.opened = false;
      // this.data = {};
      this.id = null;
      this.$refs.form.reset();
      this.success();
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new UploadAdapter(loader, "file");
      };
    },
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    },
    "data.class_type_id"(newVal) {
      if (newVal) {
        this.fetchClassSchedules(newVal);
      } else {
        this.listClassSchedule = [];
        this.data.class_schedule_id = null;
      }
    },
    "data.is_member"(val) {
      if (val === true) {
        this.data.non_member_name = null;
      } else {
        this.data.member_id = null;
      }
    },
  },
  components: {
    FileUpload,
  },
  computed: {
    memberIdRules() {
      return [
        () =>
          this.data.is_member
            ? !!this.data.member_id || "Member harus dipilih"
            : true,
      ];
    },
    nonMemberNameRules() {
      return [
        () =>
          !this.data.is_member
            ? (this.data?.non_member_name || "").toString().trim().length > 0 ||
              "Nama Non Member harus diisi"
            : true,
      ];
    },
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
    canVerification() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "verification")
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>
